<div class="db-switch-plan">
  <div class="db-switch-plan__header">
    <h1 [innerHTML]="title"></h1>
    <p class="mt8" [innerHTML]="desc"></p>
  </div>

  <div class="db-switch-plan__options mt25">
    <div class="db-switch-plan__option">
      <div>
        <div class="db-switch-plan__option-header">
          <p>Current plan</p>
          <b>{{userSubscription?.plan?.title}} Monthly</b>
        </div>
        <div class="db-switch-plan__option-price mt16">
          <p class="price">${{userSubscription?.plan?.planPrice}}<span>/mo</span></p>
          <p class="benefit">No discount</p>
        </div>
        <div class="db-switch-plan__option-benefits mt20">
          <div>
            <div class="db-switch-plan__benefit-count mr10">
              <div> <p><i class="db-icon db-icon-ds-checkmark"></i> </p> </div>
            </div>
            <p class="db-switch-plan__benefit-desc" [innerHTML]="visitors + ' monthly visitors'"></p>
          </div>
          <div class="mt10">
            <div class="db-switch-plan__benefit-count mr10">
              <div> <p><i class="db-icon db-icon-ds-checkmark"></i></p> </div>
            </div>
            <p class="db-switch-plan__benefit-desc" [innerHTML]="ssdStorage + ' SSD storage'"></p>
          </div>
          <div class="mt10 havent">
            <div class="db-switch-plan__benefit-count mr10">
              <div> <p><i class="db-icon db-icon-ds-close"></i></p> </div>
            </div>
            <p class="db-switch-plan__benefit-desc"> Cloudflare CDN </p>
          </div>
          <div class="mt10 havent">
            <div class="db-switch-plan__benefit-count mr10">
              <div> <p><i class="db-icon db-icon-ds-close"></i></p> </div>
            </div>
            <p class="db-switch-plan__benefit-desc"> 10X faster load times </p>
          </div>
          <div class="mt10 havent">
            <div class="db-switch-plan__benefit-count mr10">
              <div> <p><i class="db-icon db-icon-ds-close"></i></p> </div>
            </div>
            <p class="db-switch-plan__benefit-desc"> VIP priority support </p>
          </div>
        </div>

        <div class="db-switch-plan__switch mt20" *ngIf="switchToAnnual">
          <p (click)="confirm()">
            <span [innerHTML]="'Switch to Starter Annual'"></span>
          </p>
        </div>
      </div>
    </div>
    <div class="db-switch-plan__option annual">
      <div>
        <div class="db-switch-plan__option-header annual">
          <p><span class="gradient-color">New plan</span></p>
          <b>{{annualSubscription?.plan?.title}} Annual</b>
        </div>
        <div class="db-switch-plan__option-price mt10">
          <p class="price annual">${{userSubscription?.plan?.planPrice}}<span>/mo</span></p>
          <p class="benefit line-through">${{(monthlyPrice) | DbNumberFormatPipe : 'ceil'}} monthly price</p>
        </div>

        <div class="db-switch-plan__option-benefits mt20">
          <div>
            <div class="db-switch-plan__benefit-count annual mr10">
              <div> <p><i class="db-icon db-icon-ds-checkmark"></i> </p> </div>
            </div>
            <p class="db-switch-plan__benefit-desc" [innerHTML]="annualVisitors + ' monthly visitors'"></p>
          </div>
          <div class="mt10">
            <div class="db-switch-plan__benefit-count annual mr10">
              <div> <p><i class="db-icon db-icon-ds-checkmark"></i></p> </div>
            </div>
            <p class="db-switch-plan__benefit-desc" [innerHTML]="annualSsdStorage + ' SSD storage'"></p>
          </div>

          <div class="mt10">
            <div class="db-switch-plan__benefit-count annual mr10">
              <div> <p><i class="db-icon db-icon-ds-checkmark"></i></p> </div>
            </div>
            <p class="db-switch-plan__benefit-desc"> Cloudflare CDN </p>
          </div>

          <div class="mt10">
            <div class="db-switch-plan__benefit-count annual mr10">
              <div> <p><i class="db-icon db-icon-ds-checkmark"></i></p> </div>
            </div>
            <p class="db-switch-plan__benefit-desc"> 10X faster load times </p>
          </div>

          <div class="mt10">
            <div class="db-switch-plan__benefit-count annual mr10">
              <div> <p><i class="db-icon db-icon-ds-checkmark"></i></p> </div>
            </div>
            <p class="db-switch-plan__benefit-desc"> VIP priority support </p>
          </div>
        </div>

        <div class="db-switch-plan__btn-wrap mt40">
          <button class="ds-btn-white ds-btn-l" [ngClass]="{'ds-btn-disabled': loading || switchLoading}"
                  (click)="onClickAction.emit(true)"
                  [disabled]="loading" type="submit">
            <span *ngIf="!loading">Upgrade to {{userSubscription?.isBusiness ? 'Ultimate' : 'Premium'}} Annual</span>
            <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
          </button>
          <p class="mt10 no-additional">No additional cost</p>
        </div>
      </div>
    </div>
  </div>

</div>
